import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Dialog, DialogTitle,DialogContent, DialogActions, Button } from '@material-ui/core';
import NewThreadForm from './NewThreadForm';

const NewThreadDialog = ({ open, onSubmit, onCancel, submitting, t }) => (
  <Dialog open={open} fullWidth={true} onClose={onCancel}>
    <DialogTitle>{t('surveyDetails.boardTab.newThreadDialog.title')}</DialogTitle>
    <DialogContent>
      <NewThreadForm onSubmit={onSubmit} />
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={submitting}>
        {t('common.cancelButton')}
      </Button>
      <Button
        onClick={() => {
          document.getElementById('newThreadForm').dispatchEvent(new Event('submit', { cancelable: true }));
        }}
        disabled={submitting}
        color="primary"
        variant="contained"
      >
        {t('surveyDetails.boardTab.newThreadDialog.submitButton')}
      </Button>
    </DialogActions>
  </Dialog>
);

NewThreadDialog.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default translate()(NewThreadDialog);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/NewThreadDialog.js